import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, INTEGER, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Team from './Team'
import Account from './Account'
import Service from './Service'

export default class extends Resource {
  static name = 'consignmentMod'
  static label = 'con_mod'

  static get fields () {
    return {
      con_id: new INTEGER(),
      id: new UUID(),
      con_full: new STRING(),
      con_created_date: new DATETIME(),
      con_despatch_date: new DATETIME(),
      con_manifest_date: new DATETIME(),
      con_delivery_date: new DATETIME(),
      con_ref: new STRING(),
      con_internal_ref: new STRING(),
      con_sum_items: new INTEGER(),
      con_sum_weight: new NUMBER(),
      con_sum_cube: new NUMBER(),
      con_sender_name: new STRING(),
      con_sender_address_1: new STRING(),
      con_sender_address_2: new STRING(),
      con_sender_town: new STRING(),
      con_sender_state: new STRING(),
      con_sender_postcode: new STRING(),
      con_sender_contact: new STRING(),
      con_sender_phone: new STRING(),
      con_sender_email: new STRING(),
      con_sender_residential: new BOOLEAN(),
      con_receiver_name: new STRING(),
      con_receiver_address_1: new STRING(),
      con_receiver_address_2: new STRING(),
      con_receiver_town: new STRING(),
      con_receiver_state: new STRING(),
      con_receiver_postcode: new STRING(),
      con_receiver_contact: new STRING(),
      con_receiver_phone: new STRING(),
      con_receiver_email: new STRING(),
      con_receiver_residential: new BOOLEAN(),
      con_special_instructions: new STRING(),
      con_pal_chep: new INTEGER(),
      con_pal_loscam: new INTEGER(),
      con_pal_other: new INTEGER(),
      con_est_price: new NUMBER(),
      con_costcent: new STRING(),
      con_validated: new BOOLEAN(),
      con_is_dg: new BOOLEAN(),
      authority_to_leave: new BOOLEAN(),
      manifest_name: new STRING(),
      pricing_data: new STRING(),
      edi_id: new NUMBER(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      carrier: new ITEM(Carrier),
      service: new ITEM(Service),
      account: new ITEM(Account),
      con_type: new STRING(),
      team: new ITEM(Team),
      con_mod_carrier_notes: new STRING(),
      con_mod_explanation: new STRING(),
      con_mod_id: new STRING(),
      con_mod_internal_notes: new STRING(),
      con_note_change_id: new STRING(),
      con_origin_date: new STRING(),
      inv_receiver_postcode: new NUMBER(),
      inv_receiver_state: new STRING(),
      inv_receiver_town: new STRING(),
      inv_sender_postcode: new NUMBER(),
      inv_sender_state: new STRING(),
      inv_sender_town: new STRING(),
      inv_sum_charge_weight: new NUMBER(),
      inv_sum_cube: new NUMBER(),
      inv_sum_items: new NUMBER(),
      inv_sum_weight: new NUMBER(),
      inv_zone_from: new STRING(),
      inv_zone_to: new STRING(),
      zone_from: new STRING(),
      zone_to: new STRING(),
      uldap_id: new STRING()
    }
  }
}
